import React from "react";
import { Route, Redirect } from "react-router-dom";

interface Props {
  component: any;
  allowedRoles: string[];
  path: string;
  exact?: boolean;
}

const ProtectedRoute: React.FC<Props> = ({
  component: Component,
  allowedRoles,
  ...rest
}) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!role) {
          return <Redirect to="/staff/login" />;
        }

        if (!allowedRoles.includes(role || "")) {
          return <Redirect to="/staff/login" />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;